import React, {Fragment} from 'react';
import ResponsiveImage from '@core/scripts/templates/ResponsiveImage.jsx';
import Icon from '@bonprix/pattern-library/templates/icon';
import Button from '@bonprix/pattern-library/templates/button/default';

export default function ProductInfo({
    article,
    texts,
    intoCartClickLandmarkValue,
    goOnShoppingClickLandmarkValue,
    gotoCartButtonUrl,
    closeFunction,
}) {
    const toCartButtonAttributes = {'jsh-landmark': '', 'jsh-landmark__click': intoCartClickLandmarkValue};
    const goOnShoppingButtonAttributes = {'jsh-landmark': '', 'jsh-landmark__click': goOnShoppingClickLandmarkValue};

    return [
        renderProductThumbnail(article),
        <div className="into-cart__product-info">
            <div className="into-cart__article-details">
                <div className="into-cart__content-headline">
                    <Icon name="check" />
                    <div className="into-cart__layer-headline-message">{texts.bff_layer_add_to_basket_headline}</div>
                </div>
                {renderProductContent(article, texts)}
            </div>
            {renderButtonSection(
                ' -medium',
                texts,
                gotoCartButtonUrl,
                toCartButtonAttributes,
                goOnShoppingButtonAttributes,
                closeFunction
            )}
        </div>,
        renderButtonSection(
            ' -small',
            texts,
            gotoCartButtonUrl,
            toCartButtonAttributes,
            goOnShoppingButtonAttributes,
            closeFunction
        ),
    ];
}

function renderProductThumbnail(article) {
    if (!article) {
        return <></>;
    }
    return (
        <div className="into-cart__product-info-thumbnail">
            <a className="wishlist-item__image-container" href={article.productLink}>
                <ResponsiveImage
                    image={article.wishlistImage}
                    className="wishlist-item__image"
                    altText={article.title}
                    inlineStyle="color:transparent;"
                />
            </a>
        </div>
    );
}

function renderProductContent(article, texts) {
    if (!article) {
        return <></>;
    }
    return (
        <>
            <a href={article.productLink} className="into-cart__content-article-title">
                {article.title}
            </a>
            <div className="into-cart__content-article-details">{getArticleInfos(article, texts)}</div>
            <div className="into-cart__content-article-price">{article.price}</div>
        </>
    );
}

function renderButtonSection(
    className,
    texts,
    gotoCartButtonUrl,
    toCartButtonAttributes,
    goOnShoppingButtonAttributes,
    closeFunction
) {
    return (
        <div className={'into-cart__button-section' + className}>
            <div className="into-cart__add-to-basket-button-wrapper">
                <Button
                    href={gotoCartButtonUrl}
                    className="into-cart__add-to-basket-button"
                    attributes={toCartButtonAttributes}
                >
                    {texts.ada_to_basket_button}
                </Button>
            </div>
            <div className="into-cart__go-on-shopping-button-wrapper">
                <Button
                    className="into-cart__go-on-shopping-button"
                    attributes={goOnShoppingButtonAttributes}
                    onClick={() => closeFunction()}
                >
                    {texts.ada_go_on_shopping_button}
                </Button>
            </div>
        </div>
    );
}

function getArticleInfos(article, texts) {
    let articleInfos = '';
    if (article.variantText) {
        articleInfos += `${article.variantText}, `;
    }
    articleInfos += article.colorText;
    if (article.coliArticle) {
        articleInfos += `, ${texts.ada12_coli_article}`;
    } else if (article.displayableSizeText) {
        articleInfos += `, ${article.sizeText}`;
    }
    return articleInfos;
}
